import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import TermsUseText from "../../global-components/src/components/terms-use";

const TermsUse = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Termos de uso">
                <Helmet>
                        <title>Paçoca - Termos de uso</title>
                        <meta name="description" content={`Visualize os termos de uso do Paçoca`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Termos de uso, termos, regras}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Termos de uso`}/>
                        <meta property="og:description" content={`Visualize os termos de uso do Paçoca`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Termos de uso`}/>
                        <meta name="twitter:description" content={`Visualize os termos de uso do Paçoca`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>
                <div className="padding-big-screen">
                    <TermsUseText/>
                </div>
            </Screen>
        </>
    );
};

export default TermsUse;